import "./RequestProjectAccessModal.css";

import { Button, Modal } from "../../../../../widget";
import { useRequestProjectAccessModal } from "./useRequestProjectAccessModal";

export interface RequestProjectAccessModalProps {
  show: boolean;
  onClose: () => void;
  onRequestSent?: () => void;
}

export const RequestProjectAccessModal = ({
  show,
  onClose,
  onRequestSent,
}: RequestProjectAccessModalProps): JSX.Element => {
  const { isSendRequestLoading, onSendRequest } = useRequestProjectAccessModal(onClose, onRequestSent);

  return (
    <Modal show={show} title="Request project access" onClose={onClose} className="RequestProjectAccessModal">
      <div className="RequestProjectAccessModalContent">
        <p className="body1 RequestProjectAccessModalDescription">
          Upon being granted access to a project, you&apos;ll be able to see a higher-level of details about the
          project.
        </p>
        <div className="RequestProjectAccessModalActions">
          <Button
            text="Send request"
            variant="primary"
            corners="rounded"
            onClick={onSendRequest}
            isLoading={isSendRequestLoading}
          />
          <Button text="Cancel" variant="secondary" onClick={onClose} hasNoPadding minWidth={false} />
        </div>
      </div>
    </Modal>
  );
};
